import { Button, Container, styled, Typography } from "@mui/material";
import { heightNavbar } from "../../../utils/constants";
import { theme } from "../../theme";

export const ContainerPerson = styled(Container)(() => ({
  textAlign: "center",
  paddingBottom: 30,
  display: "flex",
  justifyContent: "center",
  minHeight: `calc(100vh - ${heightNavbar})`,
}));

export const ContainerDescription = styled(Typography)(() => ({
  fontSize: 14,
  fontWeight: 500,
  padding: theme.spacing(2, 8),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2, 2),
  },
}));

export const ButtonPerson = styled(Button)(() => ({
  backgroundColor: theme.palette.common.greenButton,
  color: theme.palette.common.blueText,
  borderRadius: 20,
  padding: "0px 20px",
  fontSize: 30,
  minWidth: 250,
}));

export const ContainerTitle = styled(Typography)(({ owner }) => ({
  fontWeight: 700,
  fontSize: 26,
  padding: theme.spacing(3, 2),
  width: owner ? "80%" : "100%",
}));
